import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import DummyImage from "assets/images/png/image.png";

const DummyImg = ({ imageUrl, sx }) => {
  const [imgSrc, setImgSrc] = useState(imageUrl ?? DummyImage);

  return (
    <Avatar
      src={imgSrc}
      alt=""
      onError={() => setImgSrc(DummyImage)}
      sx={{
        height: "48px",
        width: "48px",
        borderRadius: "8px",
        border: "1px solid",
        borderColor: "background.gray400",
        ...sx,
      }}
    />
  );
};
export default DummyImg;
